import React from 'react';
import { 
  Archive,
  Unarchive 
} from '@mui/icons-material';
import { Button } from '@mui/material';

import FabButton from "@components/input/buttons/FabButton";

interface Props {
  is_archived?: boolean;
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export default function ArchiveButton({ 
  is_archived = false,
  disabled = false,
  label = "",
  onClick 
}: Props) {

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        { is_archived ? 
          <Unarchive/>
        : 
          <Archive/>
        }
      </FabButton>
    );
  } else {
    return (
      <Button 
        disabled={disabled} 
        onClick={onClick} 
        variant="contained" color="primary">
        { is_archived ? 
          <Unarchive/>
        : 
          <Archive/>
        }&nbsp;{ label }
      </Button>
    );
  }
}
